import React from 'react';
import { WatchdogLogo } from '../pages/LandingPage';
export function Footer() {
  return <footer className="bg-slate-50 border-t border-slate-200 py-12" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="flex flex-col items-center text-center space-y-6" data-id="element-125">
          {/* Logo and Tagline */}
          <div className="flex flex-col items-center space-y-3" data-id="element-126">
            <div className="flex items-center space-x-2" data-id="element-127">
              <WatchdogLogo className="w-8 h-8" data-id="element-128" />
              <span className="text-xl font-bold text-slate-900" data-id="element-129">Watchdog</span>
            </div>
            <p className="text-slate-600 text-sm max-w-md" data-id="element-130">
              The automated trademark protection platform for modern companies
            </p>
          </div>

          {/* Divider */}
          <div className="w-full max-w-xs h-px bg-slate-200" data-id="element-131"></div>

          {/* Bottom Row */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-slate-500" data-id="element-132">
            <p data-id="element-133">
              © {new Date().getFullYear()} Watchdog Inc. All rights reserved.
            </p>
            <div className="flex items-center space-x-2" data-id="element-134">
              <span className="relative flex h-2.5 w-2.5" data-id="element-135">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-136"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-137"></span>
              </span>
              <span data-id="element-138">All systems operational</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}